import { useMutation } from '@tanstack/react-query';
import api from '../../http';
import { OCR_TIMEOUT_MS } from './ocr.constants';
import { createFormData } from '../helpers/createFormdata';
import { getApiErrorMessage, toApiError } from '../utils';

export interface OcrExtractFoliarPayload {
    file: File;
}

export interface OcrExtractFoliarResponse {
    jobId: string;
    status: 'queued';
    analysisType: 'foliar';
    createdAt: string;
}

export const usePostOcrExtractFoliar = () => {
    return useMutation<OcrExtractFoliarResponse, Error, OcrExtractFoliarPayload>({
        mutationFn: async (data) => {
            try {
                const formData = createFormData(data);
                const response = await api.post<OcrExtractFoliarResponse>('/ocr/extract/foliar', formData, { timeout: OCR_TIMEOUT_MS });
                return response.data;
            } catch (error) {
                throw toApiError(error, 'Erro ao extrair análise foliar');
            }
        },
        onSuccess: () => { },
        onError: (error) => {
            console.error(
                'Erro ao extrair análise foliar:',
                getApiErrorMessage(error, 'Erro ao extrair análise foliar')
            );
        },
    });
}
